import { render } from "./ObjectName.vue?vue&type=template&id=a2250e5e"
import script from "./ObjectName.vue?vue&type=script&lang=js"
export * from "./ObjectName.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__